const generateId = (value) => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(4)
    .substring(1);
};

export default generateId;
